import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/landing/dashboard.png'
import _imports_1 from '@/assets/icons/arrow-right-landing.svg'


const _hoisted_1 = {
  key: 0,
  class: "landing-wr"
}
const _hoisted_2 = {
  key: 1,
  class: "header-desktop"
}
const _hoisted_3 = { class: "header-controls" }
const _hoisted_4 = { class: "wrapper-desktop-switcher" }
const _hoisted_5 = {
  key: 3,
  class: "landing-body"
}
const _hoisted_6 = { class: "dashboard-wr" }
const _hoisted_7 = { class: "dashboard" }
const _hoisted_8 = {
  class: "dashboard--header",
  "data-aos": "zoom-out",
  "data-aos-once": "true"
}
const _hoisted_9 = { class: "buttons buttons-main-screen" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "contact-us banner" }
const _hoisted_12 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.activeHeaderTab?.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!$setup.isDesktop)
          ? (_openBlock(), _createBlock($setup["LandingMobileHeader"], {
              key: 0,
              onSignIn: $setup.onLogin
            }))
          : (_openBlock(), _createElementBlock("header", _hoisted_2, [
              _createElementVNode("div", {
                class: "logo",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push('/')))
              }),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode($setup["SwitchComponent"], {
                    class: "landing",
                    list: $setup.visibleHeaderTabs,
                    modelValue: $setup.activeHeaderTab,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => (($setup.activeHeaderTab) = $event)),
                      $setup.onChangeHeaderTab
                    ]
                  }, null, 8, ["list", "modelValue"])
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "divider" }, null, -1)),
                _createElementVNode("div", { class: "buttons" }, [
                  _createElementVNode("button", {
                    class: "link-primary",
                    onClick: $setup.onLogin
                  }, "sign in")
                ])
              ])
            ])),
        ($setup.activeHeaderTab.value === 'builders')
          ? (_openBlock(), _createBlock($setup["BuildersLanding"], {
              key: 2,
              onForgotPassword: _ctx.onForgotPassword,
              "login-error": _ctx.loginError,
              onLogin: _ctx.signIn
            }, null, 8, ["onForgotPassword", "login-error", "onLogin"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("section", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[3] || (_cache[3] = _createElementVNode("h1", {
                      class: "title",
                      "data-aos": "fade-down",
                      "fade-down-duration": "500",
                      "data-aos-once": "true"
                    }, [
                      _createTextVNode("House and land sales,"),
                      _createElementVNode("span", null, "simplified.")
                    ], -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("p", {
                      "data-aos": "fade-down",
                      "fade-down-duration": "500",
                      "data-aos-once": "true"
                    }, "Purpose-built to boost your land sales projects", -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode($setup["ContactUsLink"], {
                        class: "link-primary",
                        animationName: "fade-down",
                        toContactUsForm: false,
                        text: 'REQUEST A DEMO'
                      })
                    ])
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("img", {
                    class: "dashboard--img",
                    "data-aos": "zoom-in-up",
                    "data-aos-duration": "500",
                    src: _imports_0,
                    alt: "Dashboard"
                  }, null, -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode($setup["LandingSection"], {
                  class: "master-plan",
                  animationImg: 'fade-right',
                  animationText: 'fade-up',
                  image: 'master-plan.png',
                  label: 'Interactive Masterplan',
                  title: 'Bring your project to life.',
                  paragraphs: ['Allow prospective buyers to visualise your estate on an interactive masterplan. Showcase live availability, lot dimensions and sizes for buyers to compare their preferred lots and enquire about their favourites.', 'The masterplan can be easily installed on your project website with a few clicks and customised to match your brand guidelines.', 'Launching a new project? Talk to us about building your website for you.']
                }),
                _createVNode($setup["LandingSection"], {
                  class: "house-selection",
                  animationImg: 'fade-left',
                  animationText: 'fade-up',
                  image: 'house-selection.png',
                  label: ' Virtual house and land display',
                  title: 'Showcase home designs for your buyers to get excited about.',
                  paragraphs: ['For most buyers, finding the right block of land is just the beginning. In fact, more than 85% of buyers will not move forward with purchasing a lot until they have a clear understanding of build options and costs.', 'Help your buyers to get the information they need to move forward with confidence. Showcase different house design options for their preferred lots, allow them to make design selections and get quotes from local builders.']
                }, {
                  button: _withCtx(() => [
                    _createElementVNode("a", {
                      class: "link-primary",
                      "data-aos": "fade-up",
                      onClick: $setup.goToBuildersLanding
                    }, [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("LEARN MORE", -1),
                      _createElementVNode("img", {
                        class: "link-primary--icon",
                        src: _imports_1
                      }, null, -1)
                    ]))])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[7] || (_cache[7] = _createElementVNode("h2", {
                  class: "contact-us--title",
                  "data-aos": "fade-down"
                }, [
                  _createTextVNode("Complete"),
                  _createElementVNode("span", null, "plug-and-play"),
                  _createTextVNode("solution")
                ], -1)),
                _cache[8] || (_cache[8] = _createElementVNode("div", {
                  class: "contact-us--text",
                  "data-aos": "fade-down"
                }, "Start selling in 7 days", -1)),
                _createVNode($setup["ContactUsLink"], {
                  animationName: 'fade-up',
                  text: 'TALK WITH US',
                  toContactUsForm: false
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.landingSectionsData, (section) => {
                  return (_openBlock(), _createBlock($setup["LandingSection"], {
                    class: _normalizeClass(section.class),
                    animationImg: section.animationImg,
                    animationText: section.animationText,
                    key: section.label,
                    title: section.title,
                    label: section.label,
                    image: section.imageUrl,
                    paragraphs: section.paragraphs
                  }, null, 8, ["class", "animationImg", "animationText", "title", "label", "image", "paragraphs"]))
                }), 128))
              ])
            ])),
        _createVNode($setup["LandingFooter"])
      ]))
    : _createCommentVNode("", true)
}